module.exports = __webpack_public_path__ + "img/smallphoto-shape.8ea0ca25.svg";